import {shareButton} from '../features/share-button';
import {register} from '../vendor/theme-scripts/theme-sections';

register('article', [shareButton]);
